import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSaveStyle0 = cosmosIconCss;

const CosmosIconSave$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSave extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0bb27a065c255181f8114463932929095f21212c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd4513c56686e1ef447951af5aa6c18eae62af976', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ab32d37764ffd8bb468ffa3be3d9d3b95ba82985', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.75 8.187h3.285a.4.4 0 0 1 .282.683l-4.042 4.013a.4.4 0 0 1-.565 0L6.69 8.87a.4.4 0 0 1 .283-.683h3.277V3.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v4.687ZM3.506 19H18.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H18a.5.5 0 0 0-.5.5v4H4.506v-4a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSaveStyle0; }
}, [1, "cosmos-icon-save", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-save"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-save":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSave$1);
            }
            break;
    } });
}

const CosmosIconSave = CosmosIconSave$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSave, defineCustomElement };
